import { FormInstance } from 'antd'
import { EProductStatus } from 'models/product'

type TFieldPath = (string | number)[]

// Карточку на витрине и на модерации проверяем целиком: модерация ведёт к публикации
const FULL_CHECK_STATUSES = [
  EProductStatus.PUBLISHED,
  EProductStatus.DISABLED,
  EProductStatus.MODERATION
]

// Черновику нужны только название, артикул и цена. Строки вариаций без товара
// проверяем и в черновике: при сохранении они молча выбрасываются
const ALWAYS_CHECKED_FIELDS = [
  'name',
  'vendor_code',
  'price',
  '_charVariationsValidation'
]

const FREE_CHARACTERISTIC_LISTS = ['characteristics', 'optionalCharacteristics']

const isEmptyValue = (value: unknown) =>
  value === undefined ||
  value === null ||
  (typeof value === 'string' && !value.trim()) ||
  (Array.isArray(value) && !value.length)

const canSkipInDraft = (form: FormInstance, path: TFieldPath) => {
  const [field, index] = path
  if (ALWAYS_CHECKED_FIELDS.includes(String(field))) return false
  if (!isEmptyValue(form.getFieldValue(path))) return false
  // Начатую строку характеристики не пропускаем: без названия или значения
  // она тоже выбрасывается при сохранении
  if (FREE_CHARACTERISTIC_LISTS.includes(String(field)) && path.length > 2) {
    const row = form.getFieldValue([field, index]) ?? {}
    return isEmptyValue(row.name) && isEmptyValue(row.value)
  }
  return true
}

// Незаполненные поля черновику не мешают, а заполненные с ошибкой (буквы в весе,
// ноль в габаритах) не пропускаем. Возвращает значения формы или undefined
export const validateProductForm = async <T>(
  form: FormInstance,
  status: EProductStatus | undefined
): Promise<T | undefined> => {
  try {
    return (await form.validateFields()) as T
  } catch (e) {
    const { values, errorFields = [] } = (e ?? {}) as {
      values?: T
      errorFields?: { name: TFieldPath }[]
    }
    if (!status || FULL_CHECK_STATUSES.includes(status) || !errorFields.length) {
      return undefined
    }
    const skipped = errorFields.filter(({ name }) => canSkipInDraft(form, name))
    form.setFields(skipped.map(({ name }) => ({ name, errors: [] })))
    return skipped.length === errorFields.length ? values : undefined
  }
}
